import { ApiRoutes } from "../../../../../constants/api";
import { BaseAPI, RequestMethod } from "../../../base";
import { PropertyDetailRequestBody, PropertyDetailResponse } from "./types";

export class PropertyDetailAPI extends BaseAPI<
    PropertyDetailRequestBody,
    PropertyDetailResponse
> {
    protected route = ApiRoutes.property.detail;
    protected method = RequestMethod.GET;
    protected params = ["id"];
}
